import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { Register } from "@typings/entities/registers";

async function getRegisterById(id: string): Promise<Register> {
  const response = await apiClient.get<Register>(
    apiPaths.registers.getById(id),
  );
  return response.data;
}

export function useGetRegisterById(
  registerId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    registerId ? [`fetch-register-${registerId}`] : null,
    () => getRegisterById(registerId!),
    options,
  );
}
